import React from 'react';
import { flowRight } from 'lodash';
import { type WithTranslation } from '@wix/yoshi-flow-editor';
import { TextButton, TextButtonPriority } from '@wix/wix-ui-tpa/cssVars';
import PostLink from '../../../../common/components/link/post-link';
import { connect } from '../../../../common/components/runtime-context';
import withTranslate from '../../../../common/hoc/with-translate';
import { getCreatePostUrl } from '../../../../common/services/get-post-url';
import { getTopology } from '../../../../common/store/topology/topology-selectors';
import { type AppState } from '../../../../common/types';
import { ROUTE_CREATE_POST } from '../../../../post-page/constants/routes';
import { classes } from './create-post-button-desktop.st.css';

/**
 * TextButton's `as` polymorphism does not thread the target component's props
 * through its types, so PostLink's props are not otherwise visible here.
 */
const PostLinkTextButton = TextButton as unknown as React.ComponentType<
  React.ComponentProps<typeof TextButton> & React.ComponentProps<typeof PostLink>
>;

type Props = ReturnType<typeof mapRuntimeToProps> & Pick<WithTranslation, 't'>;

const CreatePostButtonDesktop = ({ t, createPostUrl }: Props) => (
  <PostLinkTextButton
    as={PostLink}
    postLink={createPostUrl}
    postPath={ROUTE_CREATE_POST}
    className={classes.root}
    priority={TextButtonPriority.primary}
    data-hook="create-post-button"
  >
    {t('create-post-button.label')}
  </PostLinkTextButton>
);

const mapRuntimeToProps = (state: AppState) => ({
  createPostUrl: getCreatePostUrl(getTopology(state)),
});

export default flowRight(withTranslate, connect(mapRuntimeToProps))(CreatePostButtonDesktop);
